import styles from './VMainNews.module.css'
import VMainTitle from "../VMainTitle"
// Modal
import useScrollBlock from '../../../../../customHooks/useScrollBlock';
import VNewsModal from '../../news/VNewsModal';
import Modal_1 from '../../../common/Modals/Modal_1';

//Truncate
import { truncateText } from '../../../../../customHooks/truncateText';

// Данные новостей (единый источник)
import { featuredNews } from '../../../../../data/news';

import { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';

const Box = ({ data }) => {
    const [content, setContent] = useState('');
    useEffect( ()=>{
        setContent(DOMPurify.sanitize(data.content)); // Sanitize content
    }, [])

    const [blockScroll, allowScroll] = useScrollBlock();
  
    const openNews = () => {
        // setTimeout(function(){}, 150);
        blockScroll()
        Modal_1.open(VNewsModal, {data});
    }

    return(
                <div onClick={openNews} className={"card__wrapper " + styles.card__wrapper}>
                    <div className={"card__content " + styles.card__content}>
                        <div className={styles.news_header}>
                            <p>{data.date}</p>
                            <div className={styles.see_more_container}>
                                <button className={styles.see_more_btn} >Подробнее</button>
                                <svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none">
                                    <path d="M1.28027 7.13574L4.20027 4.21582L1.28027 1.2959" stroke="#1F85C5" strokeWidth="0.729984" strokeLinecap="round"/>
                                </svg>
                            </div>
                            
                        </div>
                        <h3 className={styles.news_title}>{data.title}</h3>
                        <p dangerouslySetInnerHTML={{ __html: truncateText(content, 130) }} />
                    </div>
                    <div className={styles.news_img_container}>
                        <img src={'assets/img/by_page/news/' + data.img_url_main} alt={data.title} />
                    </div>
                    
                </div>
    )
}

const VMainNews = () => {

  // На главной показываем только избранные новости (featured: true) адаптивной сеткой.
  // Полный список — на странице «Новости» (ссылка в заголовке блока, url='news').
  const latestNews = featuredNews;

  return (
    <>
        <section className={styles.news}>
        <VMainTitle title='Новости' subtitle='Узнайте последние новости о нашей компании' url='news' />
            <div className={styles.wrapper}>

            {latestNews?.map( (item, k) => {
                return (
                  <div key={k} className={styles.item}>
                      <Box data={item} />
                  </div>
                )
            })}

            </div>
        </section>
    </>
  )
}

export default VMainNews